import axios from 'helpers/axios';

export const getAdminTransfers = async ({ queryKey }) => {
    const [, selectType, page, pageSize] = queryKey;
    const params: any = {
        is_received: true,
        is_receiver_admin: false,
        limit: pageSize,
        offset: page * pageSize,
    };
    if (selectType === 'processed') {
        params.is_approved = true;
    } else if (selectType === 'pending') {
        params.is_approved = false;
    }
    const { data } = await axios.get('/api/adminapi/admintransfers/', { params });

    return data;
};

export const getAdminTransferDetail = async ({ queryKey }) => {
    const [, id] = queryKey;
    const { data } = await axios.get(`/api/adminapi/admintransfers/${id}/`);

    return data;
};

export const approveAdminTransfer = async (id: number | string) => {
    const { data } = await axios.post(`/api/adminapi/admintransfers/${id}/approve/`);

    return data;
};
